var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _rect7, _rect8, _rect9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 428,
    viewBox: "0 0 427 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.099 161.711l-55.372 115.237c-5.128 10.673-18.911 19.074-30.784 18.764l-128.201-3.344c-6.409-.167-10.952-2.839-12.97-6.941l-6.803-20.523 210.533-123.375L317.469 131l6.236 17.471c.491.925.849 1.926 1.068 2.991.617 3.006.118 6.52-1.674 10.249z",
    fill: "#53978E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.943 295.712l-128.201-3.344c-6.409-.167-10.952-2.839-12.97-6.941l-6.803-20.523L317.469 131l7.304 20.462m-87.83 144.25c11.873.31 25.656-8.091 30.784-18.764l55.372-115.237c1.792-3.729 2.291-7.243 1.674-10.249m-87.83 144.25l-4.806-15.049m-80.235-123.418c5.128-10.672 18.911-19.073 30.784-18.763l128.201 3.344c7.724.201 12.737 4.04 13.886 9.636",
    stroke: "#000",
    strokeWidth: 5.259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.647,
    height: 75.039,
    rx: 10.519,
    transform: "matrix(.99966 .02608 -.4331 .90134 185.938 181.821)",
    fill: "#BAD5D2",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 171.256,
    height: 170.73,
    rx: 21.037,
    transform: "matrix(.99966 .02608 -.4331 .90134 155.807 121.839)",
    fill: "#BAD5D2",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 80.647,
    height: 75.039,
    rx: 10.519,
    transform: "matrix(.99966 .02608 -.4331 .90134 180.561 165.749)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 50.92,
    height: 25.541,
    rx: 12.77,
    transform: "matrix(-.4331 .90134 -.99966 -.02608 334.529 78.596)",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 50.92,
    height: 25.541,
    rx: 12.77,
    transform: "matrix(-.4331 .90134 -.99966 -.02608 287.112 77.368)",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 50.92,
    height: 25.541,
    rx: 12.77,
    transform: "matrix(-.4331 .90134 -.99966 -.02608 239.711 76.12)",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5.259
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.877 173.413c3.045-6.337 11.228-11.325 18.278-11.141l25.53.666c7.049.183 10.296 5.47 7.251 11.806-3.045 6.337-11.228 11.325-18.278 11.141l-25.529-.666c-7.05-.183-10.297-5.47-7.252-11.806zM316.399 216.032c3.045-6.337 11.228-11.325 18.278-11.141l25.529.666c7.05.183 10.297 5.47 7.252 11.807-3.045 6.336-11.229 11.324-18.278 11.141l-25.53-.666c-7.05-.184-10.296-5.471-7.251-11.807zM295.922 258.648c3.045-6.337 11.228-11.325 18.278-11.141l25.529.666c7.05.184 10.297 5.47 7.252 11.807-3.045 6.337-11.229 11.325-18.278 11.141l-25.53-.666c-7.05-.184-10.296-5.47-7.251-11.807z",
    fill: "#53978E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.877 173.413c3.045-6.337 11.228-11.325 18.278-11.141l25.53.666c7.049.183 10.296 5.47 7.251 11.806-3.045 6.337-11.228 11.325-18.278 11.141l-25.529-.666c-7.05-.183-10.297-5.47-7.252-11.806zM316.399 216.032c3.045-6.337 11.228-11.325 18.278-11.141l25.529.666c7.05.183 10.297 5.47 7.252 11.807-3.045 6.336-11.229 11.324-18.278 11.141l-25.53-.666c-7.05-.184-10.296-5.471-7.251-11.807zM295.922 258.648c3.045-6.337 11.228-11.325 18.278-11.141l25.529.666c7.05.184 10.297 5.47 7.252 11.807-3.045 6.337-11.229 11.325-18.278 11.141l-25.53-.666c-7.05-.184-10.296-5.47-7.251-11.807z",
    stroke: "#000",
    strokeWidth: 5.259
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.408 164.71c3.045-6.337 11.229-11.325 18.278-11.141l25.53.666c7.05.184 10.296 5.47 7.251 11.807-3.045 6.337-11.228 11.325-18.278 11.141l-25.53-.666c-7.049-.184-10.296-5.47-7.25-11.807zM58.93 207.329c3.045-6.337 11.228-11.325 18.278-11.141l25.53.666c7.049.184 10.296 5.47 7.251 11.807-3.045 6.337-11.228 11.325-18.278 11.141l-25.53-.666c-7.05-.184-10.296-5.47-7.251-11.807zM38.453 249.945c3.045-6.337 11.228-11.325 18.278-11.141l25.53.666c7.05.184 10.296 5.47 7.25 11.807-3.044 6.337-11.227 11.325-18.277 11.141l-25.53-.666c-7.05-.184-10.296-5.47-7.251-11.807z",
    fill: "#53978E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.408 164.71c3.045-6.337 11.229-11.325 18.278-11.141l25.53.666c7.05.184 10.296 5.47 7.251 11.807-3.045 6.337-11.228 11.325-18.278 11.141l-25.53-.666c-7.049-.184-10.296-5.47-7.25-11.807zM58.93 207.329c3.045-6.337 11.228-11.325 18.278-11.141l25.53.666c7.049.184 10.296 5.47 7.251 11.807-3.045 6.337-11.228 11.325-18.278 11.141l-25.53-.666c-7.05-.184-10.296-5.47-7.251-11.807zM38.453 249.945c3.045-6.337 11.228-11.325 18.278-11.141l25.53.666c7.05.184 10.296 5.47 7.25 11.807-3.044 6.337-11.227 11.325-18.277 11.141l-25.53-.666c-7.05-.184-10.296-5.47-7.251-11.807z",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 50.92,
    height: 25.541,
    rx: 12.77,
    transform: "matrix(-.4331 .90134 -.99966 -.02608 230.352 306.701)",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 50.92,
    height: 25.541,
    rx: 12.77,
    transform: "matrix(-.4331 .90134 -.99966 -.02608 182.934 305.474)",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5.259
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 50.92,
    height: 25.541,
    rx: 12.77,
    transform: "matrix(-.4331 .90134 -.99966 -.02608 135.527 304.224)",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5.259
  })));
}

export default SvgDeviceinline;